import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/Button';

interface ModalFooterProps {
  isCreate: boolean;
  onClose: () => void;
  error?: string | null | undefined;
  onDelete?: () => void;
  deleteLabel?: string;
  isDeleting?: boolean;
  onCreate?: () => void;
  createLabel?: string;
  creatingLabel?: string;
  isCreating?: boolean;
  createDisabled?: boolean;
  size?: 'sm' | 'md';
}

export const ModalFooter = ({
  isCreate,
  onClose,
  error,
  onDelete,
  deleteLabel,
  isDeleting,
  onCreate,
  createLabel,
  creatingLabel,
  isCreating,
  createDisabled,
  size = 'md',
}: ModalFooterProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex justify-between gap-2">
        {isCreate ? (
          <Button color="neutral" onClick={onClose} size={size} variant="ghost">
            {t('actions.cancel')}
          </Button>
        ) : onDelete ? (
          <Button
            color="danger"
            variant="ghost"
            size={size}
            disabled={isDeleting}
            onClick={onDelete}
          >
            {isDeleting ? t('actions.deleting') : deleteLabel}
          </Button>
        ) : null}

        {isCreate && onCreate ? (
          <Button
            color="primary"
            size={size}
            disabled={Boolean(isCreating) || Boolean(createDisabled)}
            onClick={onCreate}
          >
            {isCreating ? creatingLabel : createLabel}
          </Button>
        ) : (
          <Button color="neutral" onClick={onClose} size={size}>
            {t('actions.close')}
          </Button>
        )}
      </div>

      {error ? <p className="text-danger text-sm m-0">{error}</p> : null}
    </>
  );
};
